webpackJsonp([35783957827783],{

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(6);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _objectWithoutProperties2 = __webpack_require__(107);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(7);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Handle legacy names for image queries.
	var convertProps = function convertProps(props) {
	  var convertedProps = (0, _extends3.default)({}, props);
	  if (convertedProps.responsiveResolution) {
	    convertedProps.resolutions = convertedProps.responsiveResolution;
	    delete convertedProps.responsiveResolution;
	  }
	  if (convertedProps.responsiveSizes) {
	    convertedProps.sizes = convertedProps.responsiveSizes;
	    delete convertedProps.responsiveSizes;
	  }
	
	  return convertedProps;
	};
	
	// Cache if we've seen an image before so we don't both with
	// lazy-loading & fading in on subsequent mounts.
	var imageCache = {};
	var inImageCache = function inImageCache(props) {
	  var convertedProps = convertProps(props);
	  // Find src
	  var src = convertedProps.sizes ? convertedProps.sizes.src : convertedProps.resolutions.src;
	
	  if (imageCache[src]) {
	    return true;
	  } else {
	    imageCache[src] = true;
	    return false;
	  }
	};
	
	var io = void 0;
	var listeners = [];
	
	function getIO() {
	  if (typeof io === "undefined" && typeof window !== "undefined" && window.IntersectionObserver) {
	    io = new window.IntersectionObserver(function (entries) {
	      entries.forEach(function (entry) {
	        listeners.forEach(function (l) {
	          if (l[0] === entry.target) {
	            // Edge doesn't currently support isIntersecting, so also test for an intersectionRatio > 0
	            if (entry.isIntersecting || entry.intersectionRatio > 0) {
	              io.unobserve(l[0]);
	              l[1]();
	            }
	          }
	        });
	      });
	    }, { rootMargin: "200px" });
	  }
	
	  return io;
	}
	
	var listenToIntersections = function listenToIntersections(el, cb) {
	  getIO().observe(el);
	  listeners.push([el, cb]);
	};
	
	var isWebpSupportedCache = null;
	var isWebpSupported = function isWebpSupported() {
	  if (isWebpSupportedCache !== null) {
	    return isWebpSupportedCache;
	  }
	
	  var elem = typeof window !== "undefined" ? window.document.createElement("canvas") : {};
	  if (elem.getContext && elem.getContext("2d")) {
	    isWebpSupportedCache = elem.toDataURL("image/webp").indexOf("data:image/webp") === 0;
	  } else {
	    isWebpSupportedCache = false;
	  }
	
	  return isWebpSupportedCache;
	};
	
	var noscriptImg = function noscriptImg(props) {
	  // Check if prop exists before adding each attribute to the string output below to prevent
	  // HTML validation issues caused by empty values like width="" and height=""
	  var src = props.src ? "src=\"" + props.src + "\" " : "src=\"\" "; // required attribute
	  var srcSet = props.srcSet ? "srcset=\"" + props.srcSet + "\" " : "";
	  var sizes = props.sizes ? "sizes=\"" + props.sizes + "\" " : "";
	  var title = props.title ? "title=\"" + props.title + "\" " : "";
	  var alt = props.alt ? "alt=\"" + props.alt + "\" " : "alt=\"\" "; // required attribute
	  var width = props.width ? "width=\"" + props.width + "\" " : "";
	  var height = props.height ? "height=\"" + props.height + "\" " : "";
	  var opacity = props.opacity ? props.opacity : "1";
	  var transitionDelay = props.transitionDelay ? props.transitionDelay : "0.5s";
	
	  return "<img " + width + height + src + srcSet + alt + title + sizes + "style=\"position:absolute;top:0;left:0;transition:opacity 0.5s;transition-delay:" + transitionDelay + ";opacity:" + opacity + ";width:100%;height:100%;object-fit:cover;object-position:center\"/>";
	};
	
	var Img = function Img(props) {
	  var style = props.style,
	      onLoad = props.onLoad,
	      otherProps = (0, _objectWithoutProperties3.default)(props, ["style", "onLoad"]);
	
	  return _react2.default.createElement("img", (0, _extends3.default)({}, otherProps, {
	    onLoad: onLoad,
	    style: (0, _extends3.default)({
	      position: "absolute",
	      top: 0,
	      left: 0,
	      transition: "opacity 0.5s",
	      width: "100%",
	      height: "100%",
	      objectFit: "cover",
	      objectPosition: "center"
	    }, style)
	  }));
	};
	
	Img.propTypes = {
	  style: _propTypes2.default.object,
	  onLoad: _propTypes2.default.func
	};
	
	var Image = function (_React$Component) {
	  (0, _inherits3.default)(Image, _React$Component);
	
	  function Image(props) {
	    (0, _classCallCheck3.default)(this, Image);
	
	    // If this browser doesn't support the IntersectionObserver API
	    // we default to start downloading the image right away.
	    var _this = (0, _possibleConstructorReturn3.default)(this, _React$Component.call(this, props));
	
	    var isVisible = true;
	    var imgLoaded = true;
	    var IOSupported = false;
	
	    // If this image has already been loaded before then we can assume it's
	    // already in the browser cache so it's cheap to just show directly.
	    var seenBefore = inImageCache(props);
	
	    if (!seenBefore && typeof window !== "undefined" && window.IntersectionObserver) {
	      isVisible = false;
	      imgLoaded = false;
	      IOSupported = true;
	    }
	
	    // Always don't render image while server rendering
	    if (typeof window === "undefined") {
	      isVisible = false;
	      imgLoaded = false;
	    }
	
	    _this.state = {
	      isVisible: isVisible,
	      imgLoaded: imgLoaded,
	      IOSupported: IOSupported
	    };
	
	    _this.handleRef = _this.handleRef.bind(_this);
	    return _this;
	  }
	
	  Image.prototype.handleRef = function handleRef(ref) {
	    var _this2 = this;
	
	    if (this.state.IOSupported && ref) {
	      listenToIntersections(ref, function () {
	        _this2.setState({ isVisible: true, imgLoaded: false });
	      });
	    }
	  };
	
	  Image.prototype.render = function render() {
	    var _this3 = this;
	
	    var _convertProps = convertProps(this.props),
	        title = _convertProps.title,
	        alt = _convertProps.alt,
	        className = _convertProps.className,
	        outerWrapperClassName = _convertProps.outerWrapperClassName,
	        _convertProps$style = _convertProps.style,
	        style = _convertProps$style === undefined ? {} : _convertProps$style,
	        _convertProps$imgStyl = _convertProps.imgStyle,
	        imgStyle = _convertProps$imgStyl === undefined ? {} : _convertProps$imgStyl,
	        _convertProps$placeho = _convertProps.placeholderStyle,
	        placeholderStyle = _convertProps$placeho === undefined ? {} : _convertProps$placeho,
	        sizes = _convertProps.sizes,
	        resolutions = _convertProps.resolutions,
	        backgroundColor = _convertProps.backgroundColor,
	        Tag = _convertProps.Tag;
	
	    var bgColor = void 0;
	    if (typeof backgroundColor === "boolean") {
	      bgColor = "lightgray";
	    } else {
	      bgColor = backgroundColor;
	    }
	
	    var imagePlaceholderStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded ? 0 : 1,
	      transitionDelay: "0.25s"
	    }, imgStyle, placeholderStyle);
	
	    var imageStyle = (0, _extends3.default)({
	      opacity: this.state.imgLoaded || this.props.fadeIn === false ? 1 : 0
	    }, imgStyle);
	
	    if (sizes) {
	      var image = sizes;
	
	      // Use webp by default if browser supports it
	      if (image.srcWebp && image.srcSetWebp && isWebpSupported()) {
	        image.src = image.srcWebp;
	        image.srcSet = image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: (0, _extends3.default)({
	              position: "relative",
	              overflow: "hidden"
	            }, style),
	            ref: this.handleRef
	          },
	          _react2.default.createElement(Tag, {
	            style: {
	              width: "100%",
	              paddingBottom: 100 / image.aspectRatio + "%"
	            }
	          }),
	          image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.base64,
	            style: imagePlaceholderStyle
	          }),
	          image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              position: "absolute",
	              top: 0,
	              bottom: 0,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.35s",
	              right: 0,
	              left: 0
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            srcSet: image.srcSet,
	            src: image.src,
	            sizes: image.sizes,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.state.IOSupported && _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({ alt: alt, title: title }, image))
	            }
	          })
	        )
	      );
	    }
	
	    if (resolutions) {
	      var _image = resolutions;
	      var divStyle = (0, _extends3.default)({
	        position: "relative",
	        overflow: "hidden",
	        display: "inline-block",
	        width: _image.width,
	        height: _image.height
	      }, style);
	
	      if (style.display === "inherit") {
	        delete divStyle.display;
	      }
	
	      // Use webp by default if browser supports it
	      if (_image.srcWebp && _image.srcSetWebp && isWebpSupported()) {
	        _image.src = _image.srcWebp;
	        _image.srcSet = _image.srcSetWebp;
	      }
	
	      // The outer div is necessary to reset the z-index to 0.
	      return _react2.default.createElement(
	        Tag,
	        {
	          className: (outerWrapperClassName ? outerWrapperClassName : "") + " gatsby-image-outer-wrapper",
	          style: {
	            // Let users set component to be absolutely positioned.
	            position: style.position === "absolute" ? "initial" : "relative"
	          }
	        },
	        _react2.default.createElement(
	          Tag,
	          {
	            className: (className ? className : "") + " gatsby-image-wrapper",
	            style: divStyle,
	            ref: this.handleRef
	          },
	          _image.base64 && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.base64,
	            style: imagePlaceholderStyle
	          }),
	          _image.tracedSVG && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            src: _image.tracedSVG,
	            style: imagePlaceholderStyle
	          }),
	          bgColor && _react2.default.createElement(Tag, {
	            title: title,
	            style: {
	              backgroundColor: bgColor,
	              width: _image.width,
	              opacity: !this.state.imgLoaded ? 1 : 0,
	              transitionDelay: "0.25s",
	              height: _image.height
	            }
	          }),
	          this.state.isVisible && _react2.default.createElement(Img, {
	            alt: alt,
	            title: title,
	            width: _image.width,
	            height: _image.height,
	            srcSet: _image.srcSet,
	            src: _image.src,
	            style: imageStyle,
	            onLoad: function onLoad() {
	              _this3.setState({ imgLoaded: true });
	              _this3.props.onLoad && _this3.props.onLoad();
	            }
	          }),
	          _react2.default.createElement("noscript", {
	            dangerouslySetInnerHTML: {
	              __html: noscriptImg((0, _extends3.default)({
	                alt: alt,
	                title: title,
	                width: _image.width,
	                height: _image.height
	              }, _image))
	            }
	          })
	        )
	      );
	    }
	
	    return null;
	  };
	
	  return Image;
	}(_react2.default.Component);
	
	Image.defaultProps = {
	  fadeIn: true,
	  alt: "",
	  Tag: "div"
	};
	
	Image.propTypes = {
	  responsiveResolution: _propTypes2.default.object,
	  responsiveSizes: _propTypes2.default.object,
	  resolutions: _propTypes2.default.object,
	  sizes: _propTypes2.default.object,
	  fadeIn: _propTypes2.default.bool,
	  title: _propTypes2.default.string,
	  alt: _propTypes2.default.string,
	  className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]), // Support Glamor's css prop.
	  outerWrapperClassName: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
	  style: _propTypes2.default.object,
	  imgStyle: _propTypes2.default.object,
	  placeholderStyle: _propTypes2.default.object,
	  position: _propTypes2.default.string,
	  backgroundColor: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.bool]),
	  onLoad: _propTypes2.default.func,
	  Tag: _propTypes2.default.string
	};
	
	exports.default = Image;

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(33);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaArrowRight = function FaArrowRight(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm36.4 21.4q0 1.2-0.9 2.1l-14.5 14.5q-0.9 0.8-2 0.8-1.2 0-2-0.8l-1.7-1.7q-0.9-0.8-0.9-2t0.9-2l6.5-6.6h-15.7q-1.1 0-1.9-0.8t-0.7-2v-2.9q0-1.2 0.7-2t1.9-0.9h15.7l-6.5-6.5q-0.9-0.8-0.9-2t0.9-2l1.7-1.7q0.8-0.9 2-0.9 1.2 0 2 0.9l14.5 14.5q0.9 0.8 0.9 2z' })
	        )
	    );
	};
	
	exports.default = FaArrowRight;
	module.exports = exports['default'];

/***/ }),

/***/ 273:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(33);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCalendar = function FaCalendar(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm4.4 37.1h6.4v-6.4h-6.4v6.4z m7.8 0h7.2v-6.4h-7.2v6.4z m-7.8-7.8h6.4v-7.2h-6.4v7.2z m7.8 0h7.2v-7.2h-7.2v7.2z m-7.8-8.6h6.4v-6.4h-6.4v6.4z m16.4 16.4h7.1v-6.4h-7.1v6.4z m-8.6-16.4h7.2v-6.4h-7.2v6.4z m17.2 16.4h6.4v-6.4h-6.4v6.4z m-8.6-7.8h7.1v-7.2h-7.1v7.2z m-7.9-19.3v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.4q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.4q0.3 0 0.5-0.2t0.2-0.5z m16.5 19.3h6.4v-7.2h-6.4v7.2z m-8.6-8.6h7.1v-6.4h-7.1v6.4z m8.6 0h6.4v-6.4h-6.4v6.4z m0.7-10.7v-6.4q0-0.3-0.2-0.5t-0.5-0.2h-1.5q-0.3 0-0.5 0.2t-0.2 0.5v6.4q0 0.3 0.2 0.5t0.5 0.2h1.5q0.2 0 0.5-0.2t0.2-0.5z m8.5-1.4v28.5q0 1.2-0.8 2.1t-2 0.8h-31.4q-1.2 0-2.1-0.9t-0.8-2v-28.5q0-1.2 0.8-2t2.1-0.9h2.8v-2.1q0-1.5 1.1-2.6t2.5-1h1.4q1.5 0 2.5 1.1t1.1 2.5v2.1h8.6v-2.1q0-1.5 1-2.6t2.5-1h1.5q1.4 0 2.5 1.1t1 2.5v2.1h2.9q1.1 0 2 0.9t0.8 2z' })
	        )
	    );
	};
	
	exports.default = FaCalendar;
	module.exports = exports['default'];

/***/ }),

/***/ 944:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(33);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaCompass = function FaCompass(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm17.3 24.3l5.7-2.9-5.7-2.8v5.7z m8.6-13.2v12.1l-11.5 5.7v-12.1z m6.4 8.9q0-3.3-1.6-6.1t-4.5-4.4-6.1-1.6-6 1.6-4.5 4.4-1.6 6.1 1.6 6.1 4.4 4.4 6.1 1.6 6.1-1.6 4.5-4.4 1.6-6.1z m5 0q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z' })
	        )
	    );
	};
	
	exports.default = FaCompass;
	module.exports = exports['default'];

/***/ }),

/***/ 274:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIconBase = __webpack_require__(33);
	
	var _reactIconBase2 = _interopRequireDefault(_reactIconBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FaUser = function FaUser(props) {
	    return _react2.default.createElement(
	        _reactIconBase2.default,
	        _extends({ viewBox: '0 0 40 40' }, props),
	        _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement('path', { d: 'm35.9 31.4q0 2.6-1.6 4.2t-4.3 1.5h-19.5q-2.7 0-4.4-1.5t-1.6-4.2q0-1.2 0.1-2.3t0.3-2.5 0.6-2.4 0.9-2.2 1.4-1.8 1.9-1.2 2.5-0.4q0.2 0 1 0.5t1.6 1 2.4 1.1 3 0.5 3-0.5 2.4-1.1 1.7-1 0.9-0.5q1.4 0 2.5 0.4t1.9 1.2 1.4 1.8 0.9 2.2 0.6 2.4 0.4 2.5 0 2.3z m-7.1-20q0 3.6-2.5 6.1t-6.1 2.5-6-2.5-2.6-6.1 2.6-6 6-2.5 6.1 2.5 2.5 6z' })
	        )
	    );
	};
	
	exports.default = FaUser;
	module.exports = exports['default'];

/***/ }),

/***/ 488:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(10);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Item = __webpack_require__(489);
	
	var _Item2 = _interopRequireDefault(_Item);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Blog = function Blog(props) {
	  var posts = props.posts,
	      theme = props.theme;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "main",
	      {
	        className: _style2.default.dynamic([["3489809510", [theme.space.inset.default, "calc(" + theme.space.default + " * 1.5) 0 calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 1.5)", theme.text.maxWidth.tablet, theme.text.maxWidth.desktop]]]) + " " + "main"
	      },
	      _react2.default.createElement(
	        "ul",
	        {
	          className: _style2.default.dynamic([["3489809510", [theme.space.inset.default, "calc(" + theme.space.default + " * 1.5) 0 calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 1.5)", theme.text.maxWidth.tablet, theme.text.maxWidth.desktop]]])
	        },
	        posts.map(function (post) {
	          var node = post.node,
	              slug = post.node.fields.slug;
	
	          return _react2.default.createElement(_Item2.default, { key: slug, post: node, theme: theme });
	        })
	      )
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "3489809510",
	      css: [".main.__jsx-style-dynamic-selector{padding:0 " + theme.space.inset.default + ";}", "ul.__jsx-style-dynamic-selector{list-style:none;margin:0 auto;padding:" + ("calc(" + theme.space.default + " * 1.5) 0 calc(" + theme.space.default + " * 0.5)") + ";}", "@media screen and (min-width:601px){.main.__jsx-style-dynamic-selector{padding:0 " + ("0 calc(" + theme.space.default + " * 1.5)") + ";}ul.__jsx-style-dynamic-selector{max-width:" + theme.text.maxWidth.tablet + ";}}", "@media screen and (min-width:1025px){ul.__jsx-style-dynamic-selector{max-width:" + theme.text.maxWidth.desktop + ";}}"],
	      dynamic: [theme.space.inset.default, "calc(" + theme.space.default + " * 1.5) 0 calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 1.5)", theme.text.maxWidth.tablet, theme.text.maxWidth.desktop]
	    })
	  );
	};
	
	Blog.propTypes = {
	  posts: _propTypes2.default.array.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Blog;
	module.exports = exports["default"];

/***/ }),

/***/ 489:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(10);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _arrowRight = __webpack_require__(272);
	
	var _arrowRight2 = _interopRequireDefault(_arrowRight);
	
	var _calendar = __webpack_require__(273);
	
	var _calendar2 = _interopRequireDefault(_calendar);
	
	var _tag = __webpack_require__(135);
	
	var _tag2 = _interopRequireDefault(_tag);
	
	var _user = __webpack_require__(274);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _gatsbyImage = __webpack_require__(659);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Item = function Item(props) {
	  var theme = props.theme,
	      _props$post = props.post,
	      excerpt = _props$post.excerpt,
	      _props$post$fields = _props$post.fields,
	      slug = _props$post$fields.slug,
	      prefix = _props$post$fields.prefix,
	      _props$post$frontmatt = _props$post.frontmatter,
	      title = _props$post$frontmatt.title,
	      category = _props$post$frontmatt.category,
	      author = _props$post$frontmatt.author,
	      _props$post$frontmatt2 = _props$post$frontmatt.cover.children,
	      sizes = _props$post$frontmatt2[0].sizes;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "li",
	      {
	        className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	      },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: slug, key: slug, className: "link" },
	        _react2.default.createElement(_gatsbyImage2.default, { sizes: sizes }),
	        _react2.default.createElement(
	          "h1",
	          {
	            className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	          },
	          title,
	          " ",
	          _react2.default.createElement(_arrowRight2.default, { className: "arrow" })
	        ),
	        _react2.default.createElement(
	          "p",
	          {
	            className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]]) + " " + "meta"
	          },
	          _react2.default.createElement(
	            "span",
	            {
	              className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	            },
	            _react2.default.createElement(_calendar2.default, { size: 18 }),
	            " ",
	            prefix
	          ),
	          _react2.default.createElement(
	            "span",
	            {
	              className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	            },
	            _react2.default.createElement(_user2.default, { size: 18 }),
	            " ",
	            author
	          ),
	          category && _react2.default.createElement(
	            "span",
	            {
	              className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	            },
	            _react2.default.createElement(_tag2.default, { size: 18 }),
	            " ",
	            category
	          )
	        ),
	        _react2.default.createElement(
	          "p",
	          {
	            className: _style2.default.dynamic([["893077714", [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]]])
	          },
	          excerpt
	        )
	      )
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "893077714",
	      css: [".link{width:100%;color:" + theme.text.color.primary + ";}", "li.__jsx-style-dynamic-selector{border:1px solid transparent;border-radius:" + theme.size.radius.default + ";margin:" + ("calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)") + ";padding:" + theme.space.inset.s + ";position:relative;-webkit-transition:all " + theme.time.duration.default + ";-webkit-transition:all " + theme.time.duration.default + ";transition:all " + theme.time.duration.default + ";background:transparent;}", "li.__jsx-style-dynamic-selector .gatsby-image-outer-wrapper{border-radius:" + theme.size.radius.default + ";border:1px solid " + theme.line.color + ";overflow:hidden;}", "li.__jsx-style-dynamic-selector .gatsby-image-outer-wrapper img{z-index:-1;}", "li.__jsx-style-dynamic-selector:after{border-top:1px solid " + theme.line.color + ";content:\"\";height:0;position:absolute;bottom:" + ("calc(" + theme.space.default + " * -1.5)") + ";left:50%;-webkit-transform:translateX(-50%);-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);-webkit-transition:all " + theme.time.duration.default + ";-webkit-transition:all " + theme.time.duration.default + ";transition:all " + theme.time.duration.default + ";width:50%;}", "li.__jsx-style-dynamic-selector:first-child.__jsx-style-dynamic-selector:before{border-top:1px solid " + theme.line.color + ";content:\"\";height:0;position:absolute;top:" + ("calc(" + theme.space.default + " * -1.5)") + ";left:50%;-webkit-transform:translateX(-50%);-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);-webkit-transition:all " + theme.time.duration.default + ";-webkit-transition:all " + theme.time.duration.default + ";transition:all " + theme.time.duration.default + ";width:50%;}", "h1.__jsx-style-dynamic-selector{padding:" + theme.space.m + " " + theme.space.s + " 0;line-height:" + theme.blog.h1.lineHeight + ";font-size:" + theme.blog.h1.size + ";}", "h1.__jsx-style-dynamic-selector .arrow{display:none;}", "h1.__jsx-style-dynamic-selector:before{display:table;content:\"\";margin-bottom:-0.17em;}", "h1.__jsx-style-dynamic-selector:after{display:table;content:\"\";margin-top:-0.11em;}", ".meta.__jsx-style-dynamic-selector{display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-ms-flex-flow:row wrap;-webkit-flex-flow:row wrap;-ms-flex-flow:row wrap;flex-flow:row wrap;font-size:0.8em;padding:" + theme.space.m + " " + theme.space.s + ";background:transparent;}", ".meta.__jsx-style-dynamic-selector svg{fill:" + theme.icon.color + ";margin:" + theme.space.inline.xs + ";}", ".meta.__jsx-style-dynamic-selector span.__jsx-style-dynamic-selector{-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;text-transform:uppercase;margin:" + theme.space.xs + " " + theme.space.s + " " + theme.space.xs + " 0;}", "p.__jsx-style-dynamic-selector{line-height:1.5;padding:0 " + theme.space.s + ";}", "p.__jsx-style-dynamic-selector:before{display:table;content:\"\";margin-bottom:-0.42em;}", "p.__jsx-style-dynamic-selector:after{display:table;content:\"\";margin-top:-0.36em;}", "@media screen and (min-width:600px){li.__jsx-style-dynamic-selector{margin:" + ("calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)") + ";padding:" + theme.space.default + ";}li.__jsx-style-dynamic-selector:after{bottom:" + ("calc(" + theme.space.default + " * -2)") + ";}li.__jsx-style-dynamic-selector:first-child.__jsx-style-dynamic-selector:before{top:" + ("calc(" + theme.space.default + " * -1.75)") + ";}h1.__jsx-style-dynamic-selector{font-size:" + ("calc(" + theme.blog.h1.size + " * 1.2)") + ";padding:" + ("calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0") + ";-webkit-transition:all 0.5s;-webkit-transition:all 0.5s;transition:all 0.5s;}.meta.__jsx-style-dynamic-selector{padding:" + ("calc(" + theme.space.m + " * 1.5) " + theme.space.m) + ";}p.__jsx-style-dynamic-selector{padding:0 " + theme.space.default + ";}}", "@media screen and (min-width:1024px){li.__jsx-style-dynamic-selector{margin:" + ("calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)") + ";padding:0 0 " + ("calc(" + theme.space.default + " * 2)") + ";}li.__jsx-style-dynamic-selector:after{bottom:" + ("calc(" + theme.space.default + " * -1.5)") + ";}li.__jsx-style-dynamic-selector:first-child.__jsx-style-dynamic-selector:before{top:" + ("calc(" + theme.space.default + " * -2.75)") + ";}.blogItemLink:first-child>li.__jsx-style-dynamic-selector:before{top:" + ("calc(" + theme.space.default + " * -2.75)") + ";}h1.__jsx-style-dynamic-selector{font-size:2.5em;padding:" + ("calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0") + ";}.meta.__jsx-style-dynamic-selector{padding:" + ("calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)") + ";}p.__jsx-style-dynamic-selector{padding:" + ("0 calc(" + theme.space.default + " * 2)") + ";}@media (hover:hover){li.__jsx-style-dynamic-selector:hover{border:1px solid " + theme.line.color + ";-webkit-box-shadow:0px 3px 2px rgba(0,0,0,.03);box-shadow:0px 3px 2px rgba(0,0,0,.03);}li.__jsx-style-dynamic-selector:hover.__jsx-style-dynamic-selector:after{bottom:" + ("calc(" + theme.space.default + " * -2.5)") + ";}li.__jsx-style-dynamic-selector:hover .gatsby-image-wrapper{-webkit-transform:scale(1.1);-webkit-transform:scale(1.1);-ms-transform:scale(1.1);transform:scale(1.1);-webkit-transition:all " + theme.time.duration.default + ";-webkit-transition:all " + theme.time.duration.default + ";transition:all " + theme.time.duration.default + ";}li.__jsx-style-dynamic-selector:hover h1.__jsx-style-dynamic-selector{color:" + theme.blog.h1.hoverColor + ";}li.__jsx-style-dynamic-selector:hover .arrow{opacity:1;-webkit-transform:translateX(0);-webkit-transform:translateX(0);-ms-transform:translateX(0);transform:translateX(0);}li.__jsx-style-dynamic-selector .arrow{display:inline-block;fill:" + theme.color.special.attention + ";opacity:0;-webkit-transition:all 0.5s;-webkit-transition:all 0.5s;transition:all 0.5s;-webkit-transform:translateX(-50%);-webkit-transform:translateX(-50%);-ms-transform:translateX(-50%);transform:translateX(-50%);}}}"],
	      dynamic: [theme.text.color.primary, theme.size.radius.default, "calc(" + theme.space.default + " * 2) 0 calc(" + theme.space.default + " * 3)", theme.space.inset.s, theme.time.duration.default, theme.size.radius.default, theme.line.color, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.line.color, "calc(" + theme.space.default + " * -1.5)", theme.time.duration.default, theme.space.m, theme.space.s, theme.blog.h1.lineHeight, theme.blog.h1.size, theme.space.m, theme.space.s, theme.icon.color, theme.space.inline.xs, theme.space.xs, theme.space.s, theme.space.xs, theme.space.s, "calc(" + theme.space.default + " * 3) 0 calc(" + theme.space.default + " * 4)", theme.space.default, "calc(" + theme.space.default + " * -2)", "calc(" + theme.space.default + " * -1.75)", "calc(" + theme.blog.h1.size + " * 1.2)", "calc(" + theme.space.default + " * 1.5) " + theme.space.default + " 0", "calc(" + theme.space.m + " * 1.5) " + theme.space.m, theme.space.default, "calc(" + theme.space.default + " * 4) 0 calc(" + theme.space.default + " * 5)", "calc(" + theme.space.default + " * 2)", "calc(" + theme.space.default + " * -1.5)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * -2.75)", "calc(" + theme.space.default + " * 1.2) calc(" + theme.space.default + " * 2) 0", "calc(" + theme.space.default + " * 1.5) calc(" + theme.space.default + " * 2)\n              calc(" + theme.space.default + " * 0.5)", "0 calc(" + theme.space.default + " * 2)", theme.line.color, "calc(" + theme.space.default + " * -2.5)", theme.time.duration.default, theme.blog.h1.hoverColor, theme.color.special.attention]
	    })
	  );
	};
	
	Item.propTypes = {
	  post: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Item;
	module.exports = exports["default"];

/***/ }),

/***/ 490:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Blog = __webpack_require__(488);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Blog).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 497:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _style = __webpack_require__(10);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compass = __webpack_require__(944);
	
	var _compass2 = _interopRequireDefault(_compass);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Hero = function Hero(props) {
	  var scrollToContent = props.scrollToContent,
	      backgrounds = props.backgrounds,
	      theme = props.theme;
	
	
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(
	      "section",
	      {
	        className: _style2.default.dynamic([["2850302347", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, theme.hero.h1.size, theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.space.xl, theme.space.xl, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.3)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]]) + " " + "hero"
	      },
	      _react2.default.createElement(
	        "h1",
	        {
	          className: _style2.default.dynamic([["2850302347", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, theme.hero.h1.size, theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.space.xl, theme.space.xl, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.3)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]])
	        },
	        "Origami Owl Must Be Explored"
	      ),
	      _react2.default.createElement(
	        "button",
	        { onClick: scrollToContent, "aria-label": "scroll", className: _style2.default.dynamic([["2850302347", [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, theme.hero.h1.size, theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.space.xl, theme.space.xl, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.3)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]]])
	        },
	        _react2.default.createElement(_compass2.default, { size: 42 })
	      )
	    ),
	    _react2.default.createElement(_style2.default, {
	      styleId: "2850302347",
	      css: [".hero.__jsx-style-dynamic-selector{-webkit-box-align:center;-ms-flex-align:center;-webkit-align-items:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center;background:" + theme.hero.background + ";background-image:url(" + backgrounds.mobile + ");background-size:cover;color:" + theme.text.color.primary.inverse + ";display:-webkit-box;display:-ms-flexbox;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-flow:column nowrap;-webkit-flex-flow:column nowrap;-ms-flex-flow:column nowrap;flex-flow:column nowrap;-webkit-box-pack:center;-ms-flex-pack:center;-webkit-box-pack:center;-webkit-justify-content:center;-ms-flex-pack:center;justify-content:center;min-height:100vh;height:100px;padding:" + theme.space.inset.l + ";padding-top:" + theme.header.height.homepage + ";}", "h1.__jsx-style-dynamic-selector{text-align:center;font-size:" + theme.hero.h1.size + ";margin:" + theme.space.stack.l + ";color:" + theme.hero.h1.color + ";line-height:" + theme.hero.h1.lineHeight + ";}", "h1.__jsx-style-dynamic-selector strong{position:relative;}", "h1.__jsx-style-dynamic-selector strong:after,h1.__jsx-style-dynamic-selector strong:before{content:\"\u203A\";color:" + theme.text.color.attention + ";margin:0 " + theme.space.xs + " 0 0;text-shadow:0 0 " + theme.space.s + " " + theme.color.neutral.gray.k + ";}", "h1.__jsx-style-dynamic-selector strong:after{content:\"\u2039\";margin:0 0 0 " + theme.space.xs + ";}", "h1.__jsx-style-dynamic-selector:before{display:table;content:\"\";margin-bottom:-0.17em;}", "h1.__jsx-style-dynamic-selector:after{display:table;content:\"\";margin-top:-0.11em;}", "button.__jsx-style-dynamic-selector{background:" + theme.background.color.brand + ";border:0;border-radius:50%;font-size:" + theme.font.size.m + ";padding:" + theme.space.s + " " + theme.space.m + ";cursor:pointer;width:" + theme.space.xl + ";height:" + theme.space.xl + ";}", "button.__jsx-style-dynamic-selector:focus{outline-style:none;background:" + theme.color.brand.primary.active + ";}", "button.__jsx-style-dynamic-selector svg{fill:" + theme.color.neutral.white + ";-webkit-animation-duration:" + theme.time.duration.long + ";-webkit-animation-duration:" + theme.time.duration.long + ";animation-duration:" + theme.time.duration.long + ";-webkit-animation-name:buttonIconMove;-webkit-animation-name:buttonIconMove-__jsx-style-dynamic-selector;animation-name:buttonIconMove-__jsx-style-dynamic-selector;-webkit-animation-iteration-count:infinite;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite;}", "@-webkit-keyframes buttonIconMove{0%.__jsx-style-dynamic-selector{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}50%.__jsx-style-dynamic-selector{-webkit-transform:translateY(-10px);-webkit-transform:translateY(-10px);-ms-transform:translateY(-10px);transform:translateY(-10px);}100%.__jsx-style-dynamic-selector{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}}", "@-webkit-keyframes buttonIconMove-__jsx-style-dynamic-selector{0%{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}50%{-webkit-transform:translateY(-10px);-webkit-transform:translateY(-10px);-ms-transform:translateY(-10px);transform:translateY(-10px);}100%{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}}", "@keyframes buttonIconMove-__jsx-style-dynamic-selector{0%{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}50%{-webkit-transform:translateY(-10px);-webkit-transform:translateY(-10px);-ms-transform:translateY(-10px);transform:translateY(-10px);}100%{-webkit-transform:translateY(0);-webkit-transform:translateY(0);-ms-transform:translateY(0);transform:translateY(0);}}", "@media screen and (min-width:600px){.hero.__jsx-style-dynamic-selector{background-image:url(" + backgrounds.tablet + ");}h1.__jsx-style-dynamic-selector{max-width:90%;font-size:" + ("calc(" + theme.hero.h1.size + " * 1.3)") + ";}button.__jsx-style-dynamic-selector{font-size:" + theme.font.size.l + ";}}", "@media screen and (min-width:1024px){.hero.__jsx-style-dynamic-selector{background-image:url(" + backgrounds.desktop + ");}h1.__jsx-style-dynamic-selector{max-width:80%;font-size:" + ("calc(" + theme.hero.h1.size + " * 1.5)") + ";}button.__jsx-style-dynamic-selector{font-size:" + theme.font.size.xl + ";}}"],
	      dynamic: [theme.hero.background, backgrounds.mobile, theme.text.color.primary.inverse, theme.space.inset.l, theme.header.height.homepage, theme.hero.h1.size, theme.space.stack.l, theme.hero.h1.color, theme.hero.h1.lineHeight, theme.text.color.attention, theme.space.xs, theme.space.s, theme.color.neutral.gray.k, theme.space.xs, theme.background.color.brand, theme.font.size.m, theme.space.s, theme.space.m, theme.space.xl, theme.space.xl, theme.color.brand.primary.active, theme.color.neutral.white, theme.time.duration.long, backgrounds.tablet, "calc(" + theme.hero.h1.size + " * 1.3)", theme.font.size.l, backgrounds.desktop, "calc(" + theme.hero.h1.size + " * 1.5)", theme.font.size.xl]
	    })
	  );
	};
	
	Hero.propTypes = {
	  scrollToContent: _propTypes2.default.func.isRequired,
	  backgrounds: _propTypes2.default.object.isRequired,
	  theme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Hero;
	module.exports = exports["default"];

/***/ }),

/***/ 498:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _Hero = __webpack_require__(497);
	
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Hero).default;
	  }
	});

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	module.exports = exports["default"];

/***/ }),

/***/ 519:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.guery = undefined;
	
	var _style = __webpack_require__(10);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _layouts = __webpack_require__(43);
	
	var _Blog = __webpack_require__(490);
	
	var _Blog2 = _interopRequireDefault(_Blog);
	
	var _Hero = __webpack_require__(498);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _Seo = __webpack_require__(70);
	
	var _Seo2 = _interopRequireDefault(_Seo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexPage = function (_React$Component) {
	  _inherits(IndexPage, _React$Component);
	
	  function IndexPage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IndexPage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.separator = _react2.default.createRef(), _this.scrollToContent = function (e) {
	      _this.separator.current.scrollIntoView({ block: "start", behavior: "smooth" });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  IndexPage.prototype.render = function render() {
	    var _this2 = this;
	
	    var _props$data = this.props.data,
	        _props$data$posts$edg = _props$data.posts.edges,
	        posts = _props$data$posts$edg === undefined ? [] : _props$data$posts$edg,
	        desktop = _props$data.bgDesktop.resize.src,
	        tablet = _props$data.bgTablet.resize.src,
	        mobile = _props$data.bgMobile.resize.src,
	        facebook = _props$data.site.siteMetadata.facebook;
	
	
	    var backgrounds = {
	      desktop: desktop,
	      tablet: tablet,
	      mobile: mobile
	    };
	
	    return _react2.default.createElement(
	      _react2.default.Fragment,
	      null,
	      _react2.default.createElement(
	        _layouts.ThemeContext.Consumer,
	        null,
	        function (theme) {
	          return _react2.default.createElement(_Hero2.default, { scrollToContent: _this2.scrollToContent, backgrounds: backgrounds, theme: theme });
	        }
	      ),
	      _react2.default.createElement("hr", { ref: this.separator, className: "jsx-311820556"
	      }),
	      _react2.default.createElement(
	        _layouts.ThemeContext.Consumer,
	        null,
	        function (theme) {
	          return _react2.default.createElement(_Blog2.default, { posts: posts, theme: theme });
	        }
	      ),
	      _react2.default.createElement(_Seo2.default, { facebook: facebook }),
	      _react2.default.createElement(_style2.default, {
	        styleId: "311820556",
	        css: ["hr.jsx-311820556{margin:0;border:0;}"]
	      })
	    );
	  };
	
	  return IndexPage;
	}(_react2.default.Component);
	
	IndexPage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = IndexPage;
	
	//eslint-disable-next-line no-undef
	
	var guery = exports.guery = "** extracted graphql fragment **";
	
	//hero-background

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-70ca12a8daf30a0c9191.js